<div class="authenticated" [class.authenticated--side-panel]="!!sidePanelContent()">
  <app-side-nav [isMinimized]="sideNavMinimized()" (isMinimizedChange)="onSideNavMinimizedChange($event)" />
  <app-side-panel
    [content]="sidePanelContent()"
    [contentInputs]="sidePanelContentInputs()"
    [size]="sidePanelSize()"
    (dismissed)="dismissSidePanel()"
  />

  <div class="authenticated__wrapper flex-1 overflow-y-auto">
    <div class="authenticated__content bg-surface">
      @if (isUserGuideLoaded()) {
        @if (shouldShowFirstTouch()) {
          <first-touch [config]="firstTouchConfig()" (buttonClick)="onFirstTouchButtonClick()" />
        } @else {
          <router-outlet></router-outlet>
        }
      }
    </div>
    @if (!(authUser$ | async)?.verified) {
      <verification-banner />
    }
  </div>

  <router-outlet name="aside"></router-outlet>
</div>

@if (cmdKEnabled()) {
  <command-palette class="z-modal" />
}
